import * as React from 'react';
import { Table as UITable } from 'semantic-ui-react';
import { ItemsQuery } from '~/Api';
import { DataType } from '~/Api/Report';
import { Pagination } from '~/Pagination';
import { DecimalFormatter } from '~/Report';
var resolveSortDirection = function (sortField) {
    if ((sortField === null || sortField === void 0 ? void 0 : sortField.direction) === 'asc') {
        return 'ascending';
    }
    if ((sortField === null || sortField === void 0 ? void 0 : sortField.direction) === 'desc') {
        return 'descending';
    }
    return undefined;
};
var Cell = function (_a) {
    var header = _a.header, rowIndex = _a.rowIndex, value = _a.value;
    var cellId = "column-".concat(header.id, "-row-").concat(rowIndex);
    switch (header.dataType) {
        case DataType.decimal:
            return (<UITable.Cell data-testid={cellId} textAlign='right'>
					{value !== null ? DecimalFormatter.format(Number(value)) : '-'}
				</UITable.Cell>);
        case DataType.integer:
            return (<UITable.Cell data-testid={cellId} textAlign='right'>
					{value !== null && value !== void 0 ? value : '-'}
				</UITable.Cell>);
        case DataType.text:
        default:
            return <UITable.Cell data-testid={cellId}>{value}</UITable.Cell>;
    }
};
export var Table = function (_a) {
    var selectColumn = _a.selectColumn, headers = _a.headers, pagination = _a.pagination, query = _a.query, rows = _a.rows, onChange = _a.onChange, sort = _a.sort;
    return (<div className='tableContent' data-testid='table'>
		<UITable sortable striped size='small'>
			<UITable.Header>
				<UITable.Row>
					{headers.map(function (header) { return (<UITable.HeaderCell data-testid={"column-".concat(header.id)} key={header.id} sorted={resolveSortDirection(sort.find(function (sortField) { return sortField.property === header.id; }))} onClick={function () {
                selectColumn(header.id);
            }}>
							{header.title}
						</UITable.HeaderCell>); })}
				</UITable.Row>
			</UITable.Header>

			<UITable.Body>
				{rows.map(function (row, rowIndex) { return (<UITable.Row data-testid={"row-".concat(rowIndex)} key={rowIndex}>
						{row.map(function (value, index) { return (<Cell header={headers[index]} key={headers[index].id} rowIndex={rowIndex} value={value}/>); })}
					</UITable.Row>); })}
			</UITable.Body>

			<UITable.Footer>
				<UITable.Row>
					<UITable.HeaderCell colSpan={headers.length}>
						<Pagination page={query.page} totalPages={pagination.totalPages} onChange={function (page) {
            onChange(new ItemsQuery(page, query.perPage, query.sortFields));
        }}/>
					</UITable.HeaderCell>
				</UITable.Row>
			</UITable.Footer>
		</UITable>
	</div>);
};
